<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-row justify-start items-center w-p-100">
      <particle-select-basket [disabled]="true" class="m-r-20"></particle-select-basket>
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <mat-slide-toggle [(ngModel)]="autoSave" (change)="autoSaveChanged()">Auto Save</mat-slide-toggle>-->
        <!--          <div class="toolbar-separator m-l-10"></div>-->
        <!--        </div>-->
        <div class="button-container responsive-btn flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button"
                  particleAnalytics
                  (click)="openConversation()"
                  analyticsCategory="arrangement-details"
                  analyticsAction="Open Conversation">Open Conversation
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container responsive-btn flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button"
                  (click)="navigateToCaseFolder()"
                  particleAnalytics
                  analyticsCategory="file-manager-content"
                  analyticsAction="Add-Folder">View Documents
          </button>

          <div *ngIf="hasHallmarkTagging()" class="toolbar-separator"></div>
        </div>
        <div *ngIf="hasHallmarkTagging()"
             class="button-container responsive-btn flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button"
                  (click)="openHallmarkTagging()"
                  particleAnalytics
                  analyticsCategory="file-manager-content"
                  analyticsAction="Add-Folder">Hallmark Tagging
          </button>

          <div class="toolbar-separator action-btn"></div>
        </div>
        <!--<div class="button-container responsive-btn" fxLayout="row" fxLayoutAlign="start center">
          <button mat-button class="orbitax-flat-button"
                  (click)="createMonthlyFiling()"
                  particleAnalytics
                  analyticsCategory= "file-manager-content"
                  analyticsAction= "Add-Folder">Create Monthly Filling</button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container responsive-btn" fxLayout="row" fxLayoutAlign="start center">
          <button mat-button class="orbitax-flat-button"
                  (click)="createQuarterlyFiling()"
                  particleAnalytics
                  analyticsCategory= "file-manager-content"
                  analyticsAction= "Add-Folder">Create Quarterly Filling</button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container responsive-btn" fxLayout="row" fxLayoutAlign="start center">
          <button mat-button class="orbitax-flat-button"
                  (click)="markAnnualFiling()"
                  particleAnalytics
                  analyticsCategory= "file-manager-content"
                  analyticsAction= "Add-Folder">Mark as Annual Filling</button>

          <div class="toolbar-separator action-btn"></div>
        </div>-->


        <!-- WHEN SMALL SCREEN -->
        <div class="button-container action-btn m-l-10 flex flex-row justify-start items-center">
          <button mat-button class="grid-button" [@.disabled]="true" [matMenuTriggerFor]="menu" particleAnalytics
                  analyticsCategory="action-type-cell-viewer" analyticsAction="action-button"
                  style="border: 0!important;padding-left: 0">
            <span>Actions</span>
            <i class="fas fa-angle-down"></i></button>
          <div class="toolbar-separator"></div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item particleAnalytics
                    analyticsCategory="action-type-cell-viewer" analyticsAction="action-dropdown"
                    analyticsName="View Documents" (click)="navigateToCaseFolder()"><span>View Documents</span></button>
            <button mat-menu-item particleAnalytics
                    analyticsCategory="action-type-cell-viewer" analyticsAction="action-dropdown"
                    analyticsName="Start Conversation"><span>Open Conversation</span></button>
            <!--<button mat-menu-item particleAnalytics
                    analyticsCategory="action-type-cell-viewer" analyticsAction="action-dropdown"
                    analyticsName="Move to Arrangements" (click)="createMonthlyFiling()"><span>Create Monthly Filling</span></button>
            <button mat-menu-item particleAnalytics
                    analyticsCategory="action-type-cell-viewer" analyticsAction="action-dropdown"
                    analyticsName="Move to Arrangements" (click)="createQuarterlyFiling()"><span>Create Quarterly Filling</span></button>
            <button mat-menu-item particleAnalytics
                    analyticsCategory="action-type-cell-viewer" analyticsAction="action-dropdown"
                    analyticsName="Move to Arrangements" (click)="markAnnualFiling()" ><span>Mark as Annual Filling</span></button>-->
          </mat-menu>
        </div>
      </div>
    </div>


    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <button mat-button class="save-changes" (click)="save()"
                particleAnalytics
                analyticsCategory="Save"
                analyticsAction="Save"
                [disabled]="this.editedFields.length==0">
          <i class="fas fa-check"></i> Save Changes ({{this.editedFields?.length}})
        </button>
      </div>
    </div>
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->


        <div class="content pos-relative p-0 flex flex-col full-grow-no-shrink-no-basis" *ngIf="item">

          <particle-dynamic-form-container class="particle-dynamic-form-container"
                                           [formField]="formField"
                                           [sourceType]="sourceType"
                                           [fieldConfig]="fieldConfig"
                                           [endpointName]="endpointName"
                                           [item]="item"
                                           [showOriginal]="showOriginal"
                                           [invalidateSubject]="invalidateSubject"
                                           [showLanguageOption]="showLanguageOption"
                                           [invalidateSubject]="invalidateSubject"
                                           [editedFields]="editedFields"
                                           (valueChanged)="onValueChanged($event)"
                                           (fieldSelectionChange)="onFieldSelectionChanged($event)"
                                           (selectedSectionHearderKey)="selectedSectionIndexChange($event)"
          >
          </particle-dynamic-form-container>

        </div>


      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
